

/**
 * 
 * @param {Node | HTMLElement |Element} dom 
 * @param {string | Array<string>} eventName 
 * @param {*} cb 
 * @param {object | null} options - Refer to Option of Native Event
 * @returns 
 */
export const useDOMEvent = (dom, eventName, cb, options) => {
    if (Array.isArray(eventName)) {
        eventName.forEach((event) => dom.addEventListener(event, cb, options));
    } else {
        dom.addEventListener(eventName, cb, options);
    }
    return () => {
        if (Array.isArray(eventName)) {
            eventName.forEach((event) => dom.removeEventListener(event, cb));
        } else {
            dom.removeEventListener(eventName, cb);
        }
    }
}

/**
 * 
 * @param {Node | HTMLElement |Element} dom 
 * @param {string} eventName 
 * @param {*} cb 
 * @param {object} options - Refer to Option of Native Event
 */
export const useDOMEventOnce = (dom, eventName, cb, options) => {
    return useDOMEvent(dom, eventName, cb, { ...options, once: true });
}